module.exports = __webpack_public_path__ + "img/otp-icon.e8c30015.svg";